<template>
    <div>
        <div id="site"></div>
    </div>
</template>
<script>
export default {
    props: {
        link: String
    },
    async beforeMount(){
        window.render.methods.axios.get(`${this.link.replace('/default', '')}.json`).then(function(rsp){
            // 禁用系统微站页面的统计，否则会造成统计数据重复
            rsp.data.noTrack = true
            // 禁用系统微站页面的微信分享信息
            rsp.data.noShare = true
            new window.Vue({ render: (h) => h(window.render, { props: rsp.data }) }).$mount('#site')
        })
    }
}
</script>